import { render, staticRenderFns } from "./levenshtein.vue?vue&type=template&id=6bb49494&"
import script from "./levenshtein.vue?vue&type=script&lang=js&"
export * from "./levenshtein.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports